import React, { ReactNode } from 'react';

import PropTypes from 'prop-types';

import { stylePropType, StylableComponent } from '@adsk/alloy-react-helpers';
import theme from '@adsk/alloy-react-theme';

export type ListRowProps = StylableComponent<HTMLDivElement> & {
  value: ReactNode;
  label: ReactNode;
};

const ListRow = React.forwardRef<HTMLDivElement, ListRowProps>(
  ({ label, value, className, style, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={className}
        css={[
          {
            color: theme.colors.charcoal700,
            display: 'flex',
            marginBottom: 8,
            '&:last-child': {
              marginBottom: 0,
            },
          },
          style,
        ]}
        {...props}
      >
        <div
          css={[
            {
              width: 116,
              marginRight: 8,
              color: theme.colors.charcoal700,
            },
            theme.typography.bodyMedium,
          ]}
        >
          {label}
        </div>
        <div
          css={[
            {
              flex: 1,
              color: theme.colors.charcoal900,
            },
            theme.typography.bodyMedium,
          ]}
        >
          {value}
        </div>
      </div>
    );
  }
);

ListRow.displayName = 'ListRow';

ListRow.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** The row label */
  label: PropTypes.node.isRequired,
  /** The row value */
  value: PropTypes.node.isRequired,
};

export default ListRow;
